export enum ProbabilityMatchStatus {
	PRE_MATCH = 'PRE-MATCH',
	CLOSES_TOMORROW = 'CLOSING TOMORROW',
	CLOSES_TODAY = 'CLOSING TODAY',
	CLOSES_SOON = 'CLOSES SOON',
	IN_PROGRESS = 'LIVE',
	SUSPENDED = 'SUSPENDED',
	WALKOVER = 'WALKOVER',
	RETIREMENT = 'RETIRED',
	ABANDONED = 'ABANDONED',
	CANCELLED = 'CANCELLED',
	SETTLING = 'SETTLING...',
	SETTLED = 'SETTLED',
}
